module.exports = "./assets/images/avatar-3.svg";